document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initModosTabs();
  initResenasVideo();
  initJudgeMeTitle();
});

function initJudgeMeTitle() {
  var newTitle = 'Don’t Just Take Our Word for It!';
  function tryReplace() {
    var el = document.querySelector('.jm-review-widget-minimal-header__title');
    if (el && el.textContent.trim() !== newTitle) {
      el.textContent = newTitle;
      return true;
    }
    return false;
  }
  if (tryReplace()) return;
  var observer = new MutationObserver(function () {
    if (tryReplace()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { observer.disconnect(); }, 15000);
}

function initReveal() {
  var items = document.querySelectorAll('.bl-reveal');
  if (!items.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (el) { el.classList.add('bl-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('bl-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  items.forEach(function (el) { observer.observe(el); });
}

function initCountUp() {
  var counters = document.querySelectorAll('[data-bl-countup]');
  if (!counters.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var target = parseFloat(el.getAttribute('data-bl-countup')) || 0;
      var suffix = el.getAttribute('data-bl-suffix') || '';
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = target * eased;
        el.textContent = (Number.isInteger(target) ? Math.round(value) : value.toFixed(1)) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  counters.forEach(function (el) { observer.observe(el); });
}

function initModosTabs() {
  var wraps = document.querySelectorAll('.bl-modos');
  wraps.forEach(function (wrap) {
    var buttons = wrap.querySelectorAll('.bl-modos-tab');
    var panels = wrap.querySelectorAll('.bl-modos-panel');
    if (!buttons.length) return;
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-target');
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var panel = wrap.querySelector('[data-panel="' + target + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  });
}

function initResenasVideo() {
  var videos = document.querySelectorAll('.bl-resena-video video');
  videos.forEach(function (video) {
    var wrap = video.closest('.bl-resena-video');
    var btn = wrap ? wrap.querySelector('.bl-video-mute') : null;
    video.addEventListener('click', function () {
      if (video.paused) { video.play(); } else { video.pause(); }
    });
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        btn.classList.toggle('is-muted', video.muted);
      });
    }
  });
}
